<div *ngIf="showLoading" class="app__overlay"></div>
<div *ngIf="showLoading" class="blue-spinner"></div>
